var _line, _g, _g2, _g3, _path, _circle, _circle2, _path2, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _rect, _path3, _path4, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 206,
    viewBox: "0 0 215 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 75.5527,
    y1: 86.8407,
    x2: 116.158,
    y2: 86.8407,
    stroke: "#194590",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0398 68.8265H58.5924L58.8864 69.2944L63.8707 77.2251C64.2628 77.8489 65.172 77.8489 65.5641 77.2251L70.5484 69.2944L70.8424 68.8265H71.3951H158.955C160.06 68.8265 160.955 67.9311 160.955 66.8265V41.1659C160.955 40.0613 160.06 39.1659 158.955 39.1659H41.6006C40.496 39.1659 39.6006 40.0613 39.6006 41.1659V66.8265C39.6006 67.9311 40.496 68.8265 41.6006 68.8265H58.0398Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.8965,
    y1: 50.2103,
    x2: 151.452,
    y2: 50.2103,
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.8965,
    y1: 57.2937,
    x2: 94.4075,
    y2: 57.2937,
    stroke: "#787E8C",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.517 116.552H141.964L141.67 117.02L136.686 124.951C136.294 125.575 135.385 125.575 134.993 124.951L130.008 117.02L129.714 116.552H129.162H41.6016C40.497 116.552 39.6016 115.657 39.6016 114.552V88.8915C39.6016 87.7869 40.497 86.8915 41.6016 86.8915H158.956C160.061 86.8915 160.956 87.7869 160.956 88.8915V114.552C160.956 115.657 160.061 116.552 158.956 116.552H142.517Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 103.556,
    y2: -1,
    transform: "matrix(-1 0 0 1 152.66 98.9359)",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 46.511,
    y2: -1,
    transform: "matrix(-1 0 0 1 152.66 106.019)",
    stroke: "#787E8C",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0398 168.827H58.5924L58.8864 169.295L63.8707 177.226C64.2628 177.849 65.172 177.849 65.5641 177.226L70.5484 169.295L70.8424 168.827H71.3951H158.955C160.06 168.827 160.955 167.932 160.955 166.827V141.166C160.955 140.062 160.06 139.166 158.955 139.166H41.6006C40.496 139.166 39.6006 140.062 39.6006 141.166V166.827C39.6006 167.932 40.496 168.827 41.6006 168.827H58.0398Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.8965,
    y1: 150.211,
    x2: 151.452,
    y2: 150.211,
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.8965,
    y1: 157.294,
    x2: 94.4075,
    y2: 157.294,
    stroke: "#787E8C",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.3809 125.013L59.8613 133.597L65.9469 141.221L74.9794 131.996L68.3809 125.013Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5334,
    cy: 40.5334,
    r: 39.5334,
    transform: "matrix(-1 0 0 1 140.404 60.1539)",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4841,
    cy: 33.4841,
    r: 32.4841,
    transform: "matrix(-1 0 0 1 133.354 67.2031)",
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.511 124.995C126.686 119.262 131.283 110.435 131.283 100.533C131.283 90.9099 126.941 82.3012 120.109 76.5618H79.9105C73.0789 82.3012 68.7363 90.9099 68.7363 100.533C68.7363 110.435 73.3335 119.262 80.5088 124.995H119.511Z",
    fill: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 82.6758,
    y1: 87.3407,
    x2: 119.297,
    y2: 87.3407,
    stroke: "#194590",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 79.082,
    y1: 76.5934,
    x2: 119.852,
    y2: 76.5934,
    stroke: "#194590",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 79.082,
    y1: 124.422,
    x2: 119.852,
    y2: 124.422,
    stroke: "#194590",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 82.6758,
    y1: 105.695,
    x2: 119.297,
    y2: 105.695,
    stroke: "#194590",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 81.6758,
    y1: 114.233,
    x2: 102.414,
    y2: 114.233,
    stroke: "#194590",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 106.842,
    y1: 114.233,
    x2: 112.723,
    y2: 114.233,
    stroke: "#194590",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 74.7969,
    y1: 96.2953,
    x2: 100.986,
    y2: 96.2953,
    stroke: "#194590",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 105.143,
    y1: 96.2953,
    x2: 124.537,
    y2: 96.2953,
    stroke: "#194590",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.41421,
    y: 0.00463802,
    width: 17.7553,
    height: 41.1222,
    rx: 4,
    transform: "matrix(-0.709422 -0.704784 -0.704784 0.709422 68.3182 142.887)",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7852 131.822L66.3861 141.221",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7363 124.772L59.3373 134.171",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.1574,
    cy: 41.5159,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.083,
    cy: 59.177,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.564,
    cy: 68.2465,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.177,
    cy: 98.3184,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7218,
    cy: 69.6786,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.2746,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.778,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.058,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 133.805,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 138.578,
    cy: 190.921,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 119.961,
    cy: 196.649,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.4,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 199.676,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 190.367,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 194.187,
    cy: 93.5449,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 202.062,
    cy: 77.3159,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 196.574,
    cy: 40.7999,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 83.9238,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 49.7949,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 54.5664,
    cy: 185.909,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 23.541,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 30.4629,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 12.8007,
    cy: 94.4996,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 31.6562,
    cy: 64.6667,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 35.4746,
    cy: 22.4228,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 71.9902,
    cy: 6.19357,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 118.529,
    cy: 24.8095,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.545,
    cy: 18.8427,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.583 150.348C179.529 150.348 178.674 149.493 178.674 148.438C178.674 147.384 179.529 146.529 180.583 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6191 117.65C17.6736 117.65 18.5285 116.795 18.5285 115.741C18.5285 114.686 17.6736 113.832 16.6191 113.832",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6387 22.423C85.6932 22.423 86.548 21.5682 86.548 20.5137C86.548 19.4592 85.6932 18.6044 84.6387 18.6044",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.939 15.7402C129.885 15.7402 129.03 16.595 129.03 17.6495C129.03 18.704 129.885 19.5588 130.939 19.5588",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.816 30.0599L182.85 30.0599M172.706 45.8119L172.826 39.6066M161.131 30.0599L159.58 30.0599M172.706 20.752L172.706 8.58009M177.241 30.0599C174.258 30.0599 172.706 34.3559 172.706 34.3559C172.706 34.3559 172.229 30.0599 168.411 30.0599C170.129 30.0599 172.587 28.5086 172.826 25.406C172.826 25.406 173.104 27.9461 174.019 28.8666C174.784 29.6352 177.241 30.0599 177.241 30.0599Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.1a068eef6b3d430d0fa1d281722ef3c3.svg";
export { ForwardRef as ReactComponent };